import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { UserContextProvider } from "./context/UserContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import "./index.css";
import "react-data-grid/lib/styles.css";
import { registerSW } from "virtual:pwa-register";
import * as Sentry from "@sentry/react";
import { sentryDSN, sentryEnv, sentryRelease } from "./consts/config.js";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    updateSW(true);
  },
  onRegistered(r) {
    if (r) setInterval(() => r.update(), 5 * 60 * 1000);
  },
  onRegisteredSW(_url, r) {
    if (r) setInterval(() => r.update(), 5 * 60 * 1000);
  },
});

Sentry.init({
  dsn: sentryDSN,
  release: sentryRelease,
  environment: String(sentryEnv),

  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  tracePropagationTargets: [
    // any absolute request to *.polybee.co
    /^https:\/\/([a-z0-9-]+\.)?polybee\.co(?:\/|$)/i,

    // same-origin relative calls that start with "/api"
    // (won’t match third-party URLs like https://foo.com/api/…)
    /^\/api(?:\/|$|\?)/,
  ],
  integrations: [
    Sentry.browserTracingIntegration({
      routingInstrumentation: Sentry.reactRouterV7BrowserTracingIntegration(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      ),
    }),

    // attaches CPU profiles to the above transactions
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  enableLogs: true,
  sendDefaultPii: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
Sentry.logger.info("User triggered test log", { log_source: "sentry_test" });

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <UserContextProvider>
        <App />
      </UserContextProvider>
    </I18nextProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}
